type EventCallback = (data?: any) => void;

type UpgradeModalType = 'repeatable' | 'video' | 'audio' | 'recordLink' | 'barcode' | 'signature' | 'photo' | 'calculation';

interface EventListeners {
  [eventName: string]: EventCallback[];
}

class FormBuilderReactBridge {
  private listeners: EventListeners = {};

  public on(eventName: string, callback: EventCallback): void {
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = [];
    }
    this.listeners[eventName].push(callback);
  }

  public off(eventName: string, callback: EventCallback): void {
    if (!this.listeners[eventName]) {
      return;
    }
    this.listeners[eventName] = this.listeners[eventName].filter(
      (listener) => listener !== callback,
    );
  }

  public emit(eventName: string, data?: any): void {
    if (!this.listeners[eventName]) {
      return;
    }
    this.listeners[eventName].forEach((callback) => {
      try {
        callback(data);
      } catch (error) {
        console.error(`Error in event listener for ${eventName}:`, error);
      }
    });
  }

  // --- Methods to be called from Backbone ---

  // For upgrade modals (repeatable, video, audio, etc.)
  public openUpgradeModal(type: UpgradeModalType, props: { canManageSubscription: boolean }): void {
    this.emit('openUpgradeModalEvent', { type, props });
  }

  // For settings modals (field configuration)
  public openSettingsModal(elementWrapper: { element: any, elementId: string }): void {
    this.emit('openSettingsModalEvent', { element: elementWrapper.element, elementId: elementWrapper.elementId });
  }

  // Notify Backbone that React modal state has changed
  public notifyModalStateChange(isOpen: boolean): void {
    this.emit('reactModalStateChanged', { isOpen });
  }
}

declare global {
  interface Window {
    FormBuilderReactBridge: FormBuilderReactBridge;
  }
}

// Ensure this only runs in a browser environment
if (typeof window !== 'undefined') {
  console.log('FormBuilderReactBridge instantiated');
  window.FormBuilderReactBridge = new FormBuilderReactBridge();
} else {
  console.error('FormBuilderReactBridge is not available in this environment');
}

export default FormBuilderReactBridge; // Exporting the class for potential direct import in React modules if needed
